module.exports = __webpack_public_path__ + "assets/minusCircleFilled-c7f871.svg";